import React, { Fragment } from 'react';
import walkingaccess from '../../../../../images/walking.png';
import '../../driverFaq.css';

const WalkingAccess = () => (
  <Fragment>
    <p>
      Enter the Kimpton Hotel through the main entrance doors and walk to
      the elevator lobby. Take the elevators to the P3 parking level. As
      you exit the elevator on P3, turn left and you will see the Autzu
      vehicles.
    </p>
    <div style={{ textAlign: 'center', width: '100%' }}>
      <img src={walkingaccess} className="walking-image" />
    </div>
    <br />
  </Fragment>
);

export default WalkingAccess;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ParkingHub/Bloor/WalkingAccess.js